export const DEFAULT_PAGE_SIZE = 10;

export function buildPaginationMeta({
  currentPage = 1,
  lastPage = 1,
  perPage = DEFAULT_PAGE_SIZE,
  total = 0,
  from,
  to,
}) {
  const page = Number(currentPage) || 1;
  const pp = Number(perPage) || DEFAULT_PAGE_SIZE;
  const tot = Number(total) || 0;
  const lp = Math.max(1, Number(lastPage) || 1);

  return {
    currentPage: page,
    lastPage: lp,
    perPage: pp,
    total: tot,
    from: from ?? (tot === 0 ? 0 : (page - 1) * pp + 1),
    to: to ?? Math.min(page * pp, tot),
  };
}

export function buildPaginationFromLaravel(response, fallbackPageSize = DEFAULT_PAGE_SIZE) {
  const source = response?.data && typeof response.data === "object" && !Array.isArray(response.data)
    ? response.data
    : response;

  return buildPaginationMeta({
    currentPage: source?.current_page ?? 1,
    lastPage: source?.last_page ?? 1,
    perPage: source?.per_page ?? fallbackPageSize,
    total: source?.total ?? 0,
    from: source?.from,
    to: source?.to,
  });
}

export function paginateClientList(items, currentPage = 1, perPage = DEFAULT_PAGE_SIZE) {
  const list = Array.isArray(items) ? items : [];
  const total = list.length;
  const lastPage = Math.max(1, Math.ceil(total / perPage) || 1);
  const page = Math.min(Math.max(1, Number(currentPage) || 1), lastPage);
  const start = (page - 1) * perPage;
  const data = list.slice(start, start + perPage);

  return {
    data,
    pagination: buildPaginationMeta({
      currentPage: page,
      lastPage,
      perPage,
      total,
      from: total === 0 ? 0 : start + 1,
      to: start + data.length,
    }),
  };
}
